import GrayCard from "components/gray-card";
import Dropdown from "components/inputs/dropdown";
import Typography from "components/typography";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  setMedia: (value: any) => void;
  media?: any;
  songs: string[];
  songsLoading: boolean;
}
const RadioPromo = ({ setMedia, media, songs = [], songsLoading }: IProps) => {
  return (
    <GrayCard title="Radio Promo">
      <Typography weight="medium" color={Colors.grey400} mb="1.6">
        Pick a song you want to promote
      </Typography>

      <DropdownContainer>
        <Dropdown
          placeholder="Choose A Track"
          chosenItem={media ? media : ""}
          selectItem={(value) => {
            setMedia(value);
          }}
          items={songs}
        />
      </DropdownContainer>
    </GrayCard>
  );
};

export default RadioPromo;

const DropdownContainer = styled.div`
  width: 30rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
